import { ApiService } from '@ligo/shared/utils';
import { RESOURCES } from '../resources';

export function getLegalCheckupTypes(slug: string) {
  return ApiService.get<any>(
    `${RESOURCES.LEGAL_CHECKUP_TYPES}/${slug}`
  );
}
